export const CHAT_DRAFTS_STORAGE_KEY = "chat-drafts-v1";

export type ChatDraftRecord = {
  text: string;
  updatedAt: string;
};

export type ChatDraftsByChatId = Record<string, ChatDraftRecord>;

export const readChatDrafts = (): ChatDraftsByChatId => {
  if (typeof window === "undefined") return {};
  try {
    const raw = localStorage.getItem(CHAT_DRAFTS_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as ChatDraftsByChatId;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

export const writeChatDraft = (chatId: string, text: string) => {
  if (typeof window === "undefined") return;
  const drafts = readChatDrafts();
  if (text.trim().length === 0) {
    delete drafts[chatId];
  } else {
    drafts[chatId] = {
      text,
      updatedAt: new Date().toISOString(),
    };
  }
  localStorage.setItem(CHAT_DRAFTS_STORAGE_KEY, JSON.stringify(drafts));
};